import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HALResponse, Nullable } from "ng/src/app/shared/model/app.model";
import { ChoiceList, ChoiceListItem, ChoiceListItemQuery, ChoiceListQuery } from "ng/src/app/choice-lists/shared/choice-list.model";
import { map } from "rxjs/operators";
import { PagedEntity } from "app/shared/model/app.model";
import { GeneralParameters } from "app/shared/model/request-parameter.model";
import { Observable, of } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class ChoiceListService {
	
	constructor(
		private http: HttpClient
	) {}
	
	fetchLists(params: ChoiceListQuery = {}) {
		return this.http.get<HALResponse<{ choiceLists: ChoiceList[] }>>('/api/choiceLists', {
			params: params
		})
			.pipe(
				map(r => PagedEntity.from(r._embedded.choiceLists, r.page))
			)
	}
	
	fetchItems(params: ChoiceListItemQuery = {}) {
		return this.http.get<HALResponse<{ choiceListItems: ChoiceListItem[] }>>('/api/choiceListItems', {
			params: params
		})
			.pipe(
				map(r => PagedEntity.from(r._embedded.choiceListItems, r.page))
			)
	}
	
	copyListToLog(listId: number, logId: number) {
		return this.http.post<{ id: number }>('/api/copyListToLog', null, {
			params: { listId, logId } as GeneralParameters
		})
	}
	
	/**
	 * Checks whether the specific log has lists that match all the same values of the supplied lists.
	 *
	 * @param listId - array of list IDs to check for
	 * @param logId - Log ID to check for matching lists
	 *
	 * @returns An object with the key set to the ID of the list and the value being the corresponding list ID if it exists or null
	 */
	fetchExistInLog(listId: number[], logId: number): Observable<Record<string, Nullable<number>>> {
		if (listId.length == 0)
			return of({});
		
		return this.http.get<Record<string, Nullable<number>>>('/api/choiceListIdInLog', {
			params: {
				list: listId,
				log: logId
			} as GeneralParameters
		});
	}
}